import { useState } from 'react'
import { IAPIDataset } from 'extra/types/ApiModels'
import { DatasetItems } from './DatasetItems'
import { DatasetSettings } from './DatasetSettings'

export function DatasetDetail ({
  dataset,
  onUpdate,
  onDelete,
}: {
  dataset: IAPIDataset
  onUpdate: (d: IAPIDataset) => void
  onDelete: () => void
}) {
  const [activeTab, setActiveTab] = useState<'items' | 'settings'>('items')

  return (
    <div>
      <div className="mb-4 border-b border-gray-800">
        <nav className="flex gap-4">
          <button
            onClick={() => setActiveTab('items')}
            className={`px-3 py-1.5 text-sm transition-colors ${activeTab === 'items' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-400 hover:text-white'}`}
          >
            Items
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`px-3 py-1.5 text-sm transition-colors ${activeTab === 'settings' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-400 hover:text-white'}`}
          >
            Settings
          </button>
        </nav>
      </div>

      {activeTab === 'items'
        ? (
        <DatasetItems dataset={dataset}/>
          )
        : (
        <DatasetSettings dataset={dataset} onUpdate={onUpdate} onDelete={onDelete}/>
          )}
    </div>
  )
}
